class FaceHeaderController {
    constructor($scope, $state, $translate,Jurisdiction) {
        "ngInject";

        $scope.$state = $state;
        this.$state = $state
        this.$translate=$translate;
        this.Jurisdiction = Jurisdiction;
        this.cur_lang = window.localStorage.yuanben_lang;
        this.permission = JSON.parse(window.localStorage.getItem("loginUser"))
    }

    showSideNav() {
        // $('body').addClass('no-scroll');
        $('.mobile-side-nav').addClass('active');
        $('.mobile-side-nav-mask').addClass('active');
    }

    switching(lang){
        this.$translate.use(lang);
        window.localStorage.yuanben_lang=lang;
        location.reload();
    }
    goInHome(route){
        let params = Object.assign(this.permission,{route_name:route,checkType:"redirect_route"})
        let Identity = this.Jurisdiction.checkStatus(params)
        if(Identity.status||Identity == "admin"||Identity==2){
            this.$state.go(route)
        }else{
            this.$state.go(Identity.path)
            
        }
    }
}

export default FaceHeaderController;



// WEBPACK FOOTER //
// ./src/app/components/face/face-header/face-header.controller.js